import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import "reflect-metadata";
import { CommonModule } from '@angular/common';

const ignoreForPropsDisplayMetadataKey = Symbol("ignoreForPropsDisplay");
const PropsDisplayLabelMetadataKey = Symbol("PropsDisplayLabel");
const PropsDisplayOrderMetadataKey = Symbol("PropsDisplayOrder");
const PropsDisplayFormattedValueKey = Symbol("PropsFormattedValue");
const PropsDisplayCategoryKey = Symbol("PropsCategory");
const PropsDescriptionMetadataKey = Symbol("PropsDescription");
//const PropsDisplayFormatAsLinkMetadataKey = Symbol("PropsDisplayFormatAsLink");

export function PropsDisplayCategory(category:string):any {
  return Reflect.metadata(PropsDisplayCategoryKey, category);
}

export function IgnoreForPropsDisplay():any {
  return Reflect.metadata(ignoreForPropsDisplayMetadataKey, true);
}

export function PropsDisplayLabel(label:string):any {
  return Reflect.metadata(PropsDisplayLabelMetadataKey, label);
}

export function PropsDisplayOrder(order:number):any {
  return Reflect.metadata(PropsDisplayOrderMetadataKey, order) || 999999;
}

export function PropsDescription(desc:string):any {
  return Reflect.metadata(PropsDescriptionMetadataKey, desc);
}

/*
        function metadata(metadataKey: any, metadataValue: any): {
            (target: Function): void;
            (target: Object, propertyKey: string | symbol): void;
        };
*/
export function PropsFormattedValue(formatFn: any):any {
  return Reflect.metadata(PropsDisplayFormattedValueKey, formatFn) || 999999;
}


export type PropGridProp =
{
  key: string,
  label: string,
  value: any,
  order: number,
  category?: string,
  description?: string,

  /**
   * Styles to apply to the TD element when rendered in a table
   */
  tdStyle?: string;

  tdClass?: string;
}

@Component({
    imports: [CommonModule],
    selector: 'app-properties-grid',
    templateUrl: './properties-grid.component.html',
    styleUrls: ['./properties-grid.component.scss']
})
export class PropertiesGridComponent implements OnInit {

  @Input() useTable: boolean = false;

  // Convert PropertiesData to use a getter and setter
  // so that we can call LoadProperties() when it is set
  _props: PropGridProp[] = [];
  private _propertiesData?: PropGridProp[];
  @Input()
  get ProertiesData() {
    return this._propertiesData;
  }
  set ProertiesData(value: PropGridProp[] | undefined) {
    this._propertiesData = value;
    this._someObject = undefined;
    this.LoadProperties();
  }

  @Input() labelColWidth: string = "30%";

  private _someObject?: object;

  @Input()
  get SomeObject(): object | undefined {
    return this._someObject;
  }
  set SomeObject(value: object | undefined) {
    this._someObject = value;
    this._propertiesData = undefined;
    this.LoadProperties();
  }

  @Input() UseTitleCaseForLabels:boolean = false;

  constructor(private cd: ChangeDetectorRef) {}

  ignore(propName:string):boolean {
    return Reflect.getMetadata(ignoreForPropsDisplayMetadataKey, this._props, propName);
  }

  getLabel(propName:string):string {
    return Reflect.getMetadata(PropsDisplayLabelMetadataKey, this._props, propName) || propName.toTitleCase();
  }

  getCategory(propName:string):string {
    return Reflect.getMetadata(PropsDisplayCategoryKey, this._props, propName) || "";
  }

  getDescription(propName:string):string {
    return Reflect.getMetadata(PropsDescriptionMetadataKey, this._props, propName) || "";
  }

  getOrder(propName:string):number {
    return Reflect.getMetadata(PropsDisplayOrderMetadataKey, this._props, propName) || 999999;
  }

  getObject(propName:string):any {
    const val = this._props.find(p => p.key == propName)?.value;

    //console.log(`getObject ${propName}: ${val}`);

    if(val)
    {
      if(typeof(val) == 'object')
        return val;
      else
        return JSON.parse(val);
    }
  }
  getFormattedValue(propName:string):string {
    const fn = Reflect.getMetadata(PropsDisplayFormattedValueKey, this._props, propName);

    //let value = ( this._props as any)[propName];

    const value = this._props.find(p => p.key == propName)?.value;

    if(typeof(fn) == 'function')
      return fn(value);

    return value;
  }

  public LoadProperties()
  {
    if (this._propertiesData) {
      this._props = this._propertiesData;
    }
    else {
      if(this.SomeObject)
      {
        this._props = [];

        const obj:any = this.SomeObject;

        for (const property in obj) {
          const key = property;
          let label = key;
          const value = obj[property];
          const order:number = this.getOrder(property);
          const category: string = this.getCategory(property);
          const description: string = this.getDescription(property);

          if(!this.ignore(property))
          {
            //if(this.UseTitleCaseForLabels)
            label = this.getLabel(property);

            this._props.push({
              key: key,
              label: label,
              value: value,
              order: order || 0,
              category: category,

              description: description
            });
          }

          //console.log(`${property}: ${obj[property]}`);
        }

        // Sort by the order field
        this._props.sort((a, b) => a.order - b.order);

      }
  }
    this.cd.detectChanges();
  }

  ngOnInit(): void {

    // If SomeObject was passed in instaed of the properties data,
    // then extract the properties dats from the object
    this.LoadProperties();
  }

}
